<template>
    <a-modal
        :class="'modal epic-default'"
        :title="$t('template.modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '1536px' }"
    >
        <template #footer>
            <a-button data-cy="back-button" :type="'default'" key="back" @click="handleModalCancel">
                {{ $t('template.modal.buttons.cancel') }}
            </a-button>
        </template>
        <div class="form-container overflow-x-auto overflow-visible">
            <table-templates
                ref="TableTemplates"
                :company_id="company_id"
                :section_type="section_type"
                :user_type="user_type"
                @select="handleSelect"
            />
        </div>
    </a-modal>
</template>

<script>
import TableTemplates from '@/components/tables/Templates.vue';

export default {
    components: {
        TableTemplates,
    },
    data() {
        return {
            processing: false,
            modal_visible: false,
        };
    },
    props: {
        section_type: {
            type: String,
            default: 'cover',
        },
        company_id: {
            type: String,
            default: '',
        },
        user_type: {
            type: String,
            default: 'admin',
        },
    },
    methods: {
        showModal() {
            this.modal_visible = true;
        },
        handleModalCancel() {
            this.modal_visible = false;
        },
        handleSelect(record) {
            this.$emit('select', record);
            this.modal_visible = false;
        },
    },
};
</script>
